import * as React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import DineroFactory from 'dinero.js';
import AppState from '@webapp/store/state';

import styled from 'styled-components';
import Typography from '@components/basics/typography';

import { ListEarnings } from '@webapp/store/earnings/action-creators';
import ArtistEarningItem from './earning-item';

export const ArtistEarningList: React.FC = () => {
  const dispatch = useDispatch();
  const artistId = useSelector((state: AppState) => state.artist.active?.id);
  const releasesWithEarnings = useSelector((state: AppState) => {
    return (state.release.summary.published?.list || []).map((release) => {
      const releaseEarnings = state.earnings[artistId || '']?.find(
        (earning) => earning.releaseId === release.id
      );
      if (releaseEarnings) {
        return {
          ...release,
          streams: (release.streams || 0) + releaseEarnings.streams,
          earnings: DineroFactory({
            amount: release.earnings || 0,
            precision: 5,
            currency: 'USD',
          })
            .add(releaseEarnings.total)
            .getAmount(),
        };
      }
      return release;
    });
  });

  React.useEffect(() => {
    if (artistId) {
      dispatch(new ListEarnings('ARTIST', artistId));
    }
  }, [artistId, dispatch]);

  return (
    <>
      {releasesWithEarnings.length >= 1 ? (
        <EarningsWrapper>
          {releasesWithEarnings.map((release, i) => (
            <ArtistEarningItem
              key={`${release.id}_${i}`}
              className="item"
              type={release.type}
              srcImg={release.cover.url}
              name={release.title}
              quantity={release.streams || 0}
              earned={DineroFactory({
                amount: release.earnings || 0,
                precision: 5,
                currency: 'USD',
              })}
            />
          ))}
        </EarningsWrapper>
      ) : (
        <Typography>No earnings for now</Typography>
      )}
    </>
  );
};

export default ArtistEarningList;

const EarningsWrapper = styled.div`
  .item {
    padding: 10px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};

    ${({ theme }) => `@media screen and ${theme.device.laptopS}`} {
      padding: 20px 0;
    }

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;
